import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  addMultiEntityFavourite,
  multiEntityAllMappings,
  removeMultiEntityFavourite,
} from "../../redux/features/multientity/multientity";
import { toast } from "react-toastify";
import { toast_position } from "../../redux/features/Settings/Authorization";

import TextWithIcon from "../_utils/CommonViewAllCard/CardSubComponent/TextWithIcon";
import CardContainer from "../_utils/CommonViewAllCard/CardContainer";
import BorderAddComponent from "../_utils/BorderAddComponent";
import { GlobalConfiguration } from "../../utils/configurationProvider";
import CommonToast from "../_utils/CommonToast";
import globalText from "../../utils/globalText";
import ICONS from "../../assets/Icons";

const CloseIcon =
  "https://q2pay.in/new_assets/common/dashboard/close_with_white_circle.svg";
const NotFavouriteIcon =
  "https://q2pay.in/new_assets/common/detail_page/favourite.svg";
const FavouriteIcon =
  "https://q2pay.in/new_assets/common/detail_page/favourite_filled.svg";

export default function EntityDetailsBox({
  disabled,
  sName,
  pan,
  dismissAdvice,
  switcherAnimation,
  onSelect,
  selectedCardId,
  loading = false,
  i,
  cardTimeout,
  duration,
  isFavourite,
  favouriteClickAdvice,
  isFavouriteDisabled,
}) {
  const dispatch = useDispatch();
  const [isDismissed, setIsDismissed] = useState(false);
  const { multiEntityFavouriteLoading } = useSelector(
    (state) => state.multientity,
  );
  const onDismiss = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDismissed(true);
    setTimeout(() => {
      dismissAdvice?.call?.();
    }, 400 / 2);
  };

  const toggleFavourite = () => {
    let queryParams = {
      page_no: 1,
      page_size: 100,
      search_string: "",
      favourite: "N",
    };
    // sessionStorage.removeItem("primaryEntityData");
    const newFavourite = isFavourite ? "N" : "Y";
    const doAction = async (action) =>
      dispatch(action)
        .unwrap()
        .then(() => {
          const cachedRaw = sessionStorage.getItem("primaryEntityData");
          if (!cachedRaw) return;

          const cached = JSON.parse(cachedRaw);
          const updatedCache = { ...cached };

          for (const [key, value] of Object.entries(cached)) {
            if (key.endsWith("_Y")) {
              // Skip favourite caches here
              continue;
            }

            if (value?.mappings && Array.isArray(value.mappings)) {
              const updatedMappings = value.mappings.map((m) => {
                if (m.id === i) {
                  return { ...m, favourite: newFavourite };
                }
                return m;
              });

              updatedCache[key] = {
                ...value,
                mappings: updatedMappings,
              };
            }
          }

          for (const [key, value] of Object.entries(cached)) {
            if (!key.endsWith("_Y")) continue; // skip non-favourite caches

            const currentMappings = value?.mappings || [];

            if (newFavourite === "Y") {
              // Add to favourite list if not already present
              const exists = currentMappings.some((m) => m.id === i);
              if (!exists) {
                // Find entity from base cache
                const baseKey = key.replace(/_Y$/, "_");
                const baseData = cached[baseKey];
                const match = baseData?.mappings?.find((m) => m.id === i);

                if (match) {
                  updatedCache[key] = {
                    ...value,
                    mappings: [
                      ...currentMappings,
                      { ...match, favourite: "Y" },
                    ],
                  };
                }
              }
            } else {
              // Remove only from favourites list (not base cache)
              const updatedMappings = currentMappings.filter((m) => m.id !== i);
              updatedCache[key] = {
                ...value,
                mappings: updatedMappings,
              };
            }
          }

          sessionStorage.setItem(
            "primaryEntityData",
            JSON.stringify(updatedCache),
          );

          // : Trigger re-render event
          // window.dispatchEvent(
          //   new CustomEvent("favourite_updated", {
          //     detail: { id, newFavourite },
          //   }),
          // );
        });
    (async () => {
      if (isFavouriteDisabled) {
        CommonToast({
          text: `Log in with primary ID - ${
            JSON.parse(sessionStorage.getItem("primary_entity_data"))?.employees
              ?.user_id ?? ""
          } to edit favourites.`,
          icon: ICONS?.ERROR_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });
        return;
      }
      if (!isFavourite) {
        toast.dismiss();
        CommonToast({
          text: "Adding to favourites",
          icon: "https://q2pay.in/new_assets/gifs/inputloader_white.gif",
          variant: "var(--processing)",
          buttonNeeded: false,
        });

        try {
          await doAction(addMultiEntityFavourite({ entityId: i }));

          await dispatch(multiEntityAllMappings(queryParams));

          toast.dismiss();
          CommonToast({
            text: "Added to favourites",
            icon: "https://q2pay.in/new_assets/common/approval/select_all_with_white_filled_circle.svg",
            variant: "var(--success)",
          });
        } catch (e) {
          toast.dismiss();
        }
      } else {
        toast.dismiss();
        CommonToast({
          text: "Removing from favourites",
          icon: "https://q2pay.in/new_assets/gifs/inputloader_white.gif",
          variant: "var(--processing)",
          buttonNeeded: false,
        });

        try {
          await doAction(removeMultiEntityFavourite({ entityId: i }));

          await dispatch(multiEntityAllMappings(queryParams));

          // 5️⃣ Success toast
          toast.dismiss();
          CommonToast({
            text: "Removed from favourites",
            icon: "https://q2pay.in/new_assets/common/approval/select_all_with_white_filled_circle.svg",
            variant: "var(--success)",
          });
        } catch (e) {
          toast.dismiss();
        }
      }

      favouriteClickAdvice?.call?.();
    })();
  };

  return (
    <div
      className={` 
        ${
          isDismissed
            ? "translate-x-[100vw] opacity-0 duration-500 transition-all"
            : ""
        }
         ${switcherAnimation && "switcherAnimation"}
        `}
      style={{
        animationDelay: `${duration * globalText.MULTIANIMATION}s`,
      }}
    >
      <BorderAddComponent
        borderColor={"pending"}
        shouldAnimate={(loading || cardTimeout) && selectedCardId === i}
        showBorder={disabled && !loading && !cardTimeout}
      >
        <CardContainer
          maxWidth="var(--standard-card-width)"
          cardBgColor="primary-nav-act"
          isDisabled={(loading || cardTimeout) && selectedCardId !== i}
          key={i}
          onClickHandler={() => {
            if (!disabled && !loading && !cardTimeout) onSelect();
          }}
          minHeight={GlobalConfiguration.entityCardMinHeight}
        >
          <card-body>
            <TextWithIcon
              type={"Text"}
              fontWeight={"semibold"}
              text={sName}
              subText="Name"
              textColor={"var(--text-primary)"}
              iconComponentArray={[
                {
                  icon:
                    i !== "-1"
                      ? isFavourite
                        ? FavouriteIcon
                        : NotFavouriteIcon
                      : FavouriteIcon,
                  isDisabled: loading || cardTimeout || disabled,
                  onClick: (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    if (i === "-1") {
                      if (!disabled)
                        toast.info(
                          "Primary entity cannot be removed from favourites ",
                          toast_position,
                        );
                    } else {
                      if (
                        !disabled &&
                        !loading &&
                        !cardTimeout &&
                        !multiEntityFavouriteLoading
                      )
                        toggleFavourite();
                    }
                  },
                },
                {
                  icon: CloseIcon,
                  isDisabled: loading || cardTimeout || disabled || i === "-1",
                  onClick: (e) => {
                    if (i === "-1") {
                      toast.info(
                        "Primary entity cannot be removed",
                        toast_position,
                      );
                      return;
                    }
                    if (!disabled && !loading && !cardTimeout) onDismiss(e);
                  },
                },
              ]}
            />

            <TextWithIcon
              text={pan}
              type={"Text"}
              subText={"PAN number"}
              fontWeight={"semibold"}
              textColor={"var(--text-primary)"}
            />
          </card-body>
        </CardContainer>
      </BorderAddComponent>
    </div>
  );
}
